import mapboxgl from "mapbox-gl";

export const addSourcesIfNotExist = (
    map: mapboxgl.Map,
    source_names: string[]
): void => {
    source_names.forEach((source_name: string) => {
        if (!map.getSource(source_name)) {
            map.addSource(source_name, {
                type: "geojson",
                data: {
                    type: "FeatureCollection",
                    features: [],
                },
                generateId: true,
                promoteId: "id",
            });
        }
    });
};
